import request from '../request.js'

// 获取虚拟组织架构信息（张卫华）
const getGroupStationByGroupId = function (data) {
    return request({
        url: 'sysStation/getGroupStationByGroupId',
        method: 'post',
        data
    })
}

export {
    getGroupStationByGroupId,
}